export const USAGE_TYPES = ["PERSONAL", "BUSINESS", "BOTH"];

export const USAGE_OPTIONS = [
  { label: "Personal", value: "PERSONAL" },
  { label: "Business", value: "BUSINESS" },
  { label: "Both", value: "BOTH" },
];

export const usageLabel = (value) =>
  USAGE_OPTIONS.find((option) => option.value === value)?.label ?? "";
